module.exports = __webpack_public_path__ + "img/35-2.0b8ef2bd.jpg";